/**
 * MUSKLE Bee Hive — persistent partner attribution (session-wide).
 * Storage: localStorage muskleBeeHiveActivePartner (+ legacy cookie/session bee_hive_ref for cart).
 *
 * REQUIRED PLATFORM RULE — do not remove when editing partner menus, footers, templates, or cards.
 * These Bee Hive pages are demo templates only. Do not activate partner referral until real approved partner routing exists.
 * DEMO_PARTNER_ROUTES never set, persist, or read referral state — always clear stale state on visit.
 * Future real partner routes must NOT be listed in DEMO_PARTNER_ROUTES.
 */
(function (global) {
  'use strict';

  var STORAGE_KEY = 'muskleBeeHiveActivePartner';
  var LEGACY_SESSION = 'bee_hive_ref';
  var LEGACY_COOKIE = 'bee_hive_ref';
  var MAX_LEN = 64;
  var COOKIE_MAX_AGE = 30 * 24 * 60 * 60;

  /** Public Bee Hive demo templates — not live approved partner sales routes. Referral disabled. */
  var DEMO_PARTNER_ROUTES = {
    '/pages/store-fitclub': true,
    '/pages/store-lina': true,
  };

  var PARTNERS = {
    john: {
      ref: 'john',
      partnerName: 'Coach John',
      partnerCode: 'JOHN10',
      returnUrl: '/pages/partners-john',
      returnLabel: "Terug naar John\u2019s store",
    },
    mila: {
      ref: 'mila',
      partnerName: 'Mia Moves',
      partnerCode: 'MILA10',
      returnUrl: '/pages/store-mia',
      returnLabel: 'Terug naar Mia Moves',
    },
    fitclub: {
      ref: 'fitclub',
      partnerName: 'FitClub Antwerp',
      partnerCode: 'FITCLUB10',
      returnUrl: '/pages/store-fitclub',
      returnLabel: 'Terug naar FitClub Antwerp',
    },
    lina: {
      ref: 'lina',
      partnerName: 'Lina Balance',
      partnerCode: 'LINA10',
      returnUrl: '/pages/store-lina',
      returnLabel: 'Terug naar Lina Balance',
    },
  };

  /** Legacy ref aliases → canonical partner key */
  var REF_ALIASES = {
    mia: 'mila',
  };

  function isDemoPartnerRoute(pathname) {
    var p = normalizePath(pathname != null ? pathname : global.location.pathname);
    if (Object.prototype.hasOwnProperty.call(DEMO_PARTNER_ROUTES, p)) return true;
    for (var route in DEMO_PARTNER_ROUTES) {
      if (Object.prototype.hasOwnProperty.call(DEMO_PARTNER_ROUTES, route) && p.endsWith(route)) {
        return true;
      }
    }
    return false;
  }

  function isReferralActivationEnabled() {
    return !isDemoPartnerRoute();
  }

  function sanitize(raw) {
    if (raw == null || typeof raw !== 'string') return '';
    var s = String(raw).toLowerCase().replace(/[^a-z0-9_-]/g, '');
    if (s.length > MAX_LEN) s = s.slice(0, MAX_LEN);
    return s;
  }

  function resolveRef(raw) {
    var s = sanitize(raw);
    if (!s) return '';
    if (Object.prototype.hasOwnProperty.call(PARTNERS, s)) return s;
    if (Object.prototype.hasOwnProperty.call(REF_ALIASES, s)) return REF_ALIASES[s];
    return '';
  }

  function normalizePath(p) {
    if (p == null || typeof p !== 'string') return '';
    var x = String(p).split('?')[0].split('#')[0].trim().toLowerCase();
    if (x.length > 1 && x.slice(-1) === '/') x = x.slice(0, -1);
    return x;
  }

  function readUrlRefRaw() {
    try {
      var sp = new URLSearchParams(global.location.search);
      var a = sp.get('bee_hive_ref');
      if (a != null && String(a).trim() !== '') return String(a).trim();
      var b = sp.get('ref');
      if (b != null && String(b).trim() !== '') return String(b).trim();
      var c = sp.get('utm_partner');
      if (c != null && String(c).trim() !== '') return String(c).trim();
    } catch (e) {
      /* ignore */
    }
    return '';
  }

  function qaLog(message, detail) {
    try {
      var sp = new URLSearchParams(global.location.search);
      var isPreview = sp.has('preview_theme_id');
      var isLocal =
        global.location.hostname === 'localhost' || global.location.hostname === '127.0.0.1';
      if (!isPreview && !isLocal && !global.MUSKLE_BH_QA) return;
      if (global.console && typeof global.console.info === 'function') {
        global.console.info('[MUSKLE Bee Hive QA]', message, detail || '');
      }
    } catch (e) {
      /* ignore */
    }
  }

  function readStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || typeof data !== 'object' || !data.ref) return null;
      if (!data.setViaUrlRef) return null;
      var ref = resolveRef(data.ref);
      if (!ref) return null;
      return buildState(ref, data.updatedAt, true);
    } catch (e) {
      return null;
    }
  }

  function buildState(ref, updatedAt, setViaUrlRef) {
    var base = PARTNERS[ref];
    if (!base) return null;
    return {
      ref: base.ref,
      partnerName: base.partnerName,
      partnerCode: base.partnerCode,
      returnUrl: base.returnUrl,
      returnLabel: base.returnLabel,
      createdAt: updatedAt || new Date().toISOString(),
      updatedAt: updatedAt || new Date().toISOString(),
      setViaUrlRef: !!setViaUrlRef,
    };
  }

  function persistLegacyRef(ref) {
    if (!ref) return;
    try {
      sessionStorage.setItem(LEGACY_SESSION, ref);
    } catch (e) {
      /* ignore */
    }
    var secure = global.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      LEGACY_COOKIE +
      '=' +
      encodeURIComponent(ref) +
      '; Path=/; Max-Age=' +
      COOKIE_MAX_AGE +
      '; SameSite=Lax' +
      secure;
  }

  function setActivePartner(ref, source) {
    if (isDemoPartnerRoute()) return null;
    var key = resolveRef(ref);
    if (!key) return null;
    if (source !== 'url') return null;
    var now = new Date().toISOString();
    var prev = readStored();
    var state = buildState(key, now, true);
    if (!state) return null;
    if (prev && prev.ref === state.ref) {
      state.createdAt = prev.createdAt || now;
    }
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
      /* ignore */
    }
    persistLegacyRef(key);
    try {
      global.dispatchEvent(
        new CustomEvent('muskle-bee-hive-partner-changed', { detail: { state: state, source: source || 'set' } })
      );
    } catch (err) {
      /* ignore */
    }
    return state;
  }

  function clearLegacyRef() {
    try {
      sessionStorage.removeItem(LEGACY_SESSION);
    } catch (e) {
      /* ignore */
    }
    try {
      var secure = global.location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = LEGACY_COOKIE + '=; Path=/; Max-Age=0; SameSite=Lax' + secure;
    } catch (e2) {
      /* ignore */
    }
  }

  function clearActivePartner() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }
    clearLegacyRef();
    try {
      global.dispatchEvent(new CustomEvent('muskle-bee-hive-partner-changed', { detail: { state: null, source: 'clear' } }));
    } catch (err) {
      /* ignore */
    }
  }

  var ACCOUNT_SESSION_LAST_KEY = 'muskleAccountSessionLast';

  function bindLogoutClear() {
    document.addEventListener(
      'click',
      function (event) {
        var t = event.target;
        if (!t || typeof t.closest !== 'function') return;
        var link = t.closest('a[href*="/account/logout"]');
        if (!link) return;
        clearActivePartner();
      },
      true
    );
  }

  function watchAccountLogout() {
    var probe = global.MuskleAccountSession && global.MuskleAccountSession.probe;
    if (!probe) return;
    probe()
      .then(function (loggedIn) {
        var prev = '';
        try {
          prev = sessionStorage.getItem(ACCOUNT_SESSION_LAST_KEY) || '';
        } catch (e) {
          /* ignore */
        }
        if (prev === 'in' && !loggedIn) {
          clearActivePartner();
        }
        try {
          sessionStorage.setItem(ACCOUNT_SESSION_LAST_KEY, loggedIn ? 'in' : 'out');
        } catch (e2) {
          /* ignore */
        }
      })
      .catch(function () {
        /* ignore */
      });
  }

  function bindStorageSync() {
    global.addEventListener('storage', function (event) {
      if (event.key !== STORAGE_KEY) return;
      if (event.newValue != null && event.newValue !== '') return;
      try {
        global.dispatchEvent(
          new CustomEvent('muskle-bee-hive-partner-changed', { detail: { state: null, source: 'storage' } })
        );
      } catch (err) {
        /* ignore */
      }
    });
  }

  function getActivePartner() {
    return readStored();
  }

  function syncFromPage() {
    if (isDemoPartnerRoute()) {
      var hadState = !!readStored();
      clearActivePartner();
      qaLog('Demo partner route — referral disabled; cleared partner state', {
        path: global.location.pathname,
        hadState: hadState,
        urlRefIgnored: readUrlRefRaw() || null,
      });
      return null;
    }
    var urlRef = resolveRef(readUrlRefRaw());
    if (urlRef) return setActivePartner(urlRef, 'url');
    return readStored();
  }

  function isInternalUrl(url) {
    try {
      var u = new URL(url, global.location.origin);
      return u.origin === global.location.origin;
    } catch (e) {
      return false;
    }
  }

  function isProductPath(pathname) {
    return normalizePath(pathname).indexOf('/products/') === 0;
  }

  function hrefHasRef(href, ref) {
    try {
      var u = new URL(href, global.location.origin);
      var existing = resolveRef(u.searchParams.get('ref') || u.searchParams.get('bee_hive_ref') || '');
      if (existing && existing !== ref) return true;
      return u.searchParams.has('ref') || u.searchParams.has('bee_hive_ref');
    } catch (e) {
      return false;
    }
  }

  function appendRefToUrl(href, ref) {
    if (!href || !ref) return href;
    if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0 || href.indexOf('javascript:') === 0) {
      return href;
    }
    try {
      var u = new URL(href, global.location.origin);
      if (!isInternalUrl(u.href)) return href;
      if (!isProductPath(u.pathname)) return href;
      if (hrefHasRef(u.href, ref)) return href;
      u.searchParams.set('ref', ref);
      return u.pathname + u.search + u.hash;
    } catch (e) {
      return href;
    }
  }

  function patchProductLinks(root) {
    if (isDemoPartnerRoute()) return;
    var state = getActivePartner();
    if (!state || !state.ref || !state.setViaUrlRef) return;
    var scope = root && root.querySelectorAll ? root : document;
    var links = scope.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute('href');
      if (!href) continue;
      var next = appendRefToUrl(href, state.ref);
      if (next !== href) a.setAttribute('href', next);
    }
  }

  function onDocumentClick(event) {
    if (isDemoPartnerRoute()) return;
    var state = getActivePartner();
    if (!state || !state.ref || !state.setViaUrlRef) return;
    var t = event.target;
    if (!t || typeof t.closest !== 'function') return;
    var a = t.closest('a[href*="/products/"]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || !isInternalUrl(href)) return;
    if (hrefHasRef(href, state.ref)) return;
    var next = appendRefToUrl(href, state.ref);
    if (next === href) return;
    a.setAttribute('href', next);
  }

  function init() {
    syncFromPage();
    patchProductLinks(document);
    bindLogoutClear();
    bindStorageSync();
    watchAccountLogout();
    document.addEventListener('click', onDocumentClick, true);
    global.addEventListener('popstate', function () {
      syncFromPage();
      patchProductLinks(document);
    });
    document.addEventListener('shopify:section:load', function (ev) {
      if (ev && ev.target) patchProductLinks(ev.target);
    });
  }

  global.MuskleBeeHivePartner = {
    STORAGE_KEY: STORAGE_KEY,
    PARTNERS: PARTNERS,
    DEMO_PARTNER_ROUTES: DEMO_PARTNER_ROUTES,
    sanitize: sanitize,
    resolveRef: resolveRef,
    getActivePartner: getActivePartner,
    setActivePartner: setActivePartner,
    clearActivePartner: clearActivePartner,
    syncFromPage: syncFromPage,
    isDemoPartnerRoute: isDemoPartnerRoute,
    isReferralActivationEnabled: isReferralActivationEnabled,
    readUrlRef: function () {
      if (isDemoPartnerRoute()) return '';
      return resolveRef(readUrlRefRaw());
    },
    appendRefToUrl: appendRefToUrl,
    patchProductLinks: patchProductLinks,
  };

  syncFromPage();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window);
